var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Dimmer, Form, Loader, Message } from "semantic-ui-react";
import ErrorDisplay from "../ErrorDisplay";
import { EditKitForm as AutomatedIfEditKitForm, serializeAutomatedIfKit } from "../kit/automated-gold-if/EditKitForm";
import AdminEditKitForm from "../kit/automated-pro/AdminEditKitForm";
import { buildEditFormStateHandlerForComponent } from "../kit/FormState";
import { EditKitForm as EncoderEditKitForm, serializeManualGoldIfKit } from "../kit/manual-gold-if/EditKitForm";
import ManualProAdminKitForm from "../kit/manual-pro/ManualProAdminKitForm";
import { default as EditKitForm } from "../kit/rna-fish/EditKitForm";
import { AutomatedGoldIfKit, AutomatedProKit, ManualGoldIfKit, ManualProKit, RnaFishKit } from "../kit/rna-fish/KitModel";
import { ErrorElements } from "../kit/rna-fish/NewRnaFishKitPage";
import { EditKitForm as SecondaryIfEditKitForm, serializeSecondaryIfKit } from "../kit/secondary-if/EditKitForm";
import { adminConfigurations } from "../KitDeserializer";
import { postJsonWithAuthn } from "../RequestHelpers";
var InternalUserEditKitModal = /** @class */ (function (_super) {
    __extends(InternalUserEditKitModal, _super);
    function InternalUserEditKitModal(props) {
        var _this = _super.call(this, props) || this;
        _this.setRnaFishFormState = buildEditFormStateHandlerForComponent('rnaFishFormState', _this);
        _this.setSecondaryIfFormState = buildEditFormStateHandlerForComponent('secondaryIfFormState', _this);
        _this.setRnaCishFormState = buildEditFormStateHandlerForComponent('rnaCishAdminFormState', _this);
        _this.setManualProFormState = buildEditFormStateHandlerForComponent('manualProAdminFormState', _this);
        _this.setEncoderFormState = buildEditFormStateHandlerForComponent('encoderFormState', _this);
        _this.setAutomatedIfFormState = buildEditFormStateHandlerForComponent('automatedIfFormState', _this);
        _this.kitPriceUrlPath = "/admin/orders/id/" + encodeURIComponent(_this.props.orderId) + "/price-kit";
        _this.submit = function () {
            _this.setState({
                loading: true,
                success: false,
            }, function () {
                var body;
                switch (_this.props.kitType) {
                    case KitType.LegacyRnaFish:
                        body = EditKitForm.serializeRnaFishKit(_this.state.rnaFishFormState);
                        break;
                    case KitType.NewRnaFish:
                        body = EditKitForm.serializeRnaFishKit(_this.state.rnaFishFormState);
                        break;
                    case KitType.LegacyIhc2:
                        body = serializeSecondaryIfKit(_this.state.secondaryIfFormState);
                        break;
                    case KitType.NewIhc2:
                        body = serializeSecondaryIfKit(_this.state.secondaryIfFormState);
                        break;
                    case KitType.RnaCish:
                        body = AdminEditKitForm.serializeAutomatedProKit(_this.state.rnaCishAdminFormState);
                        break;
                    case KitType.ManualPro:
                        body = ManualProAdminKitForm.serializeManualProAdminKit(_this.state.manualProAdminFormState);
                        break;
                    case KitType.Encoder:
                        body = serializeManualGoldIfKit(_this.state.encoderFormState);
                        break;
                    case KitType.AutomatedGoldIf:
                        body = serializeAutomatedIfKit(_this.state.automatedIfFormState, _this.props.catalog.secondaryIfCatalog);
                }
                postJsonWithAuthn(_this.props.endpoint, JSON.stringify(body))
                    .then(function (resp) {
                    if (resp.status === 400) {
                        return resp.json().then(function (json) {
                            return new ErrorElements(json.errors);
                        });
                    }
                    else if (resp.ok) {
                        return Promise.resolve(undefined);
                    }
                    else {
                        return Promise.resolve(new ErrorElements([{
                                path: '/',
                                msg: 'An unexpected error occurred'
                            }]));
                    }
                })
                    .then(function (json) {
                    if (json !== undefined) {
                        _this.setState({
                            errors: json.errors,
                            loading: false
                        });
                    }
                    else {
                        _this.setState({
                            errors: [],
                            loading: false,
                            success: true
                        });
                    }
                })
                    .catch(function (rej) {
                    console.error("Couldn't update kit: " + rej);
                });
            });
        };
        _this.state = {
            loading: false,
            success: false,
            errors: [],
            rnaFishFormState: props.initialRnaFishFormState,
            secondaryIfFormState: props.initialSecondaryIfFormState,
            rnaCishAdminFormState: _this.props.initialRnaCishFormState,
            manualProAdminFormState: _this.props.initialManualProFormState,
            encoderFormState: _this.props.initialEncoderFormState,
            automatedIfFormState: _this.props.initialAutomatedIfFormState
        };
        return _this;
    }
    InternalUserEditKitModal.prototype.render = function () {
        return React.createElement(Dimmer.Dimmable, { as: Form, error: this.state.errors.length > 0 },
            React.createElement(Dimmer, { active: this.state.loading, inverted: true },
                React.createElement(Loader, null)),
            this.props.kitType === KitType.LegacyRnaFish
                && React.createElement(EditKitForm
                // use a price endpoint that uses the order's price params, not the authn user's
                , { 
                    // use a price endpoint that uses the order's price params, not the authn user's
                    kitPriceUrlPath: this.kitPriceUrlPath, catalog: this.props.catalog.rnaCatalog, formState: this.state.rnaFishFormState, loadPriceOnMount: this.props.loadPricesOnMount, restrictCustomTargetProbeSetSizeToCatalog: false, enableNegativeControlProbe: this.props.negativeControlProbe, enableCustomPrice: true, enableAmplifierCustomScale: true, enableProbeSetCustomScale: true, enableBufferCustomScale: true, enableAdminSystems: false, setFormState: this.setRnaFishFormState, legacy: true, showErrors: true }),
            this.props.kitType === KitType.NewRnaFish
                && React.createElement(EditKitForm
                // use a price endpoint that uses the order's price params, not the authn user's
                , { 
                    // use a price endpoint that uses the order's price params, not the authn user's
                    kitPriceUrlPath: this.kitPriceUrlPath, catalog: this.props.catalog.rnaCatalog, formState: this.state.rnaFishFormState, loadPriceOnMount: this.props.loadPricesOnMount, restrictCustomTargetProbeSetSizeToCatalog: false, enableNegativeControlProbe: this.props.negativeControlProbe, enableCustomPrice: true, enableAmplifierCustomScale: true, enableProbeSetCustomScale: true, enableBufferCustomScale: true, enableAdminSystems: true, setFormState: this.setRnaFishFormState, legacy: false, showErrors: true }),
            this.props.kitType === KitType.ManualPro
                && React.createElement(ManualProAdminKitForm, { kitPriceUrlPath: this.kitPriceUrlPath, catalog: this.props.catalog.rnaCatalog, formState: this.state.manualProAdminFormState, loadPriceOnMount: this.props.loadPricesOnMount, enableNegativeControlProbe: this.props.negativeControlProbe, enableCustomPrice: true, setFormState: this.setManualProFormState, showErrors: true }),
            this.props.kitType === KitType.LegacyIhc2
                && React.createElement(SecondaryIfEditKitForm, { kitPriceUrlPath: this.kitPriceUrlPath, catalog: this.props.catalog.secondaryIfCatalog, formState: this.state.secondaryIfFormState, loadPriceOnMount: this.props.loadPricesOnMount, setFormState: this.setSecondaryIfFormState, legacy: true, enableCustomPrice: true, showErrors: true }),
            this.props.kitType === KitType.NewIhc2
                && React.createElement(SecondaryIfEditKitForm, { kitPriceUrlPath: this.kitPriceUrlPath, catalog: this.props.catalog.secondaryIfCatalog, formState: this.state.secondaryIfFormState, loadPriceOnMount: this.props.loadPricesOnMount, setFormState: this.setSecondaryIfFormState, legacy: false, enableCustomPrice: true, showErrors: true }),
            this.props.kitType === KitType.RnaCish
                && React.createElement(AdminEditKitForm, { kitPriceUrlPath: this.kitPriceUrlPath, catalog: this.props.catalog.rnaCatalog, kitConfigurations: adminConfigurations, formState: this.state.rnaCishAdminFormState, loadPriceOnMount: this.props.loadPricesOnMount, enableCustomPrice: true, setFormState: this.setRnaCishFormState }),
            this.props.kitType === KitType.AutomatedGoldIf
                && React.createElement(AutomatedIfEditKitForm, { kitPriceUrlPath: this.kitPriceUrlPath, catalog: this.props.catalog.secondaryIfCatalog, formState: this.state.automatedIfFormState, loadPriceOnMount: this.props.loadPricesOnMount, enableCustomPrice: true, setFormState: this.setAutomatedIfFormState, showErrors: true }),
            this.props.kitType === KitType.Encoder
                && React.createElement(EncoderEditKitForm, { kitPriceUrlPath: this.kitPriceUrlPath, catalog: this.props.catalog.secondaryIfCatalog, formState: this.state.encoderFormState, loadPriceOnMount: this.props.loadPricesOnMount, enableCustomPrice: true, enableAdminSystems: true, setFormState: this.setEncoderFormState, showErrors: true }),
            this.state.success &&
                React.createElement(Message, { positive: true }, "Kit saved."),
            React.createElement(ErrorDisplay, { errors: this.state.errors, errorPath: '/' }),
            React.createElement(Button, { disabled: this.state.success, icon: 'save', label: 'Save', labelPosition: 'left', onClick: this.submit, positive: true, style: { marginTop: '2rem' } }));
    };
    return InternalUserEditKitModal;
}(React.PureComponent));
export { InternalUserEditKitModal };
// TODO perhaps there is a good way to ADT this whole concept to avoid duplicated state, etc
// Since this is also used to edit new kits, we don't have an existing kit that determines the appropriate kit
// type, so we need this hint
export var KitType;
(function (KitType) {
    KitType["LegacyRnaFish"] = "LegacyRnaFish";
    KitType["NewRnaFish"] = "NewRnaFish";
    KitType["LegacyIhc2"] = "LegacyIhc2";
    KitType["NewIhc2"] = "NewIhc2";
    KitType["RnaCish"] = "RnaCish";
    KitType["ManualPro"] = "ManualPro";
    KitType["Encoder"] = "Encoder";
    KitType["AutomatedGoldIf"] = "AutomatedGoldIf";
})(KitType || (KitType = {}));
export var RnaCatalogType;
(function (RnaCatalogType) {
    RnaCatalogType["RnaFish"] = "RnaFish";
    RnaCatalogType["RnaCish"] = "RnaCish";
})(RnaCatalogType || (RnaCatalogType = {}));
export var determineKitType = function (kit) {
    if (kit instanceof RnaFishKit) {
        if (kit.legacy) {
            return KitType.LegacyRnaFish;
        }
        else {
            return KitType.NewRnaFish;
        }
    }
    else if (kit instanceof AutomatedProKit) {
        return KitType.RnaCish;
    }
    else if (kit instanceof ManualProKit) {
        return KitType.ManualPro;
    }
    else if (kit instanceof ManualGoldIfKit) {
        return KitType.Encoder;
    }
    else if (kit instanceof AutomatedGoldIfKit) {
        return KitType.AutomatedGoldIf;
    }
    else if (kit.legacy) {
        // Legacy IHC kit
        return KitType.LegacyIhc2;
    }
    else {
        // New IHC kit
        return KitType.NewIhc2;
    }
};
//# sourceMappingURL=EditOrderKit.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/admin/EditOrderKit.js
// module id = 129
// module chunks = 0